import React, { Component } from 'react';
import BoxInputFieldComponent from './BoxInputFieldComponent';
import { PropTypes } from 'prop-types';
import format from 'string-template';
import _ from 'lodash';
import { CHECKBOX } from '../constants';

class CheckboxInputFieldComponent extends Component {
    errorMessage = () =>
        this.props.minRequired === 1 && this.props.options.length === 1
            ? this.props.i18nFeatureForm.BOX_REQUIRED
            : this.props.i18nFeatureForm.BOX_ATLEAST_REQUIRED;

    validateDefault = value =>
        this.props.minRequired &&
        (_.isNil(value) ||
            (this.props.options.length === 1 && value === false) ||
            value.length < this.props.minRequired)
            ? format(this.errorMessage(), this.props.minRequired)
            : '';

    handleOnChange = (event, inputValue, optionValue) => {
        const { onChange } = this.props;
        if (this.props.options.length === 1) {
            onChange && onChange(event.target.checked);
            return event.target.checked;
        } else {
            const newValue = [...inputValue];
            if (event.target.checked) {
                newValue.push(optionValue);
            } else {
                newValue.splice(newValue.indexOf(optionValue), 1);
            }
            onChange && onChange(newValue);
            return newValue;
        }
    };

    handleChecked = (currentValue, optionValue) =>
        this.props.options.length === 1
            ? currentValue === true
            : currentValue.includes(optionValue);

    getInputValue = input => (input.value ? input.value : []);

    getInputName = (input, index) => `${input.name}[${index}]`;

    render() {
        const { validate } = this.props;
        const minRequired = _.toInteger(this.props.minRequired);

        return (
            <BoxInputFieldComponent
                {...this.props}
                typeBox={CHECKBOX}
                isRequired={minRequired > 0}
                validate={validate ? validate : this.validateDefault}
                handleOnChange={this.handleOnChange}
                handleChecked={this.handleChecked}
                getInputName={this.getInputName}
                getInputValue={this.getInputValue}
            />
        );
    }
}

// See proptypes in ./BoxInputFieldComponent.js for global Field props
BoxInputFieldComponent.propTypes = {
    minRequired: PropTypes.number,
    onChange: PropTypes.func
};

export default CheckboxInputFieldComponent;



// WEBPACK FOOTER //
// ./src/components/form/boxInput/CheckboxInputFieldComponent.js